import {
  FETCH_OFFICES_REQUEST,
  FETCH_OFFICES_SUCCESS,
  FETCH_OFFICES_FAILURE,
  CREATE_OFFICE_REQUEST,
  CREATE_OFFICE_SUCCESS,
  CREATE_OFFICE_FAILURE,
  UPDATE_OFFICE_REQUEST,
  UPDATE_OFFICE_SUCCESS,
  UPDATE_OFFICE_FAILURE,
  DELETE_OFFICE_REQUEST,
  DELETE_OFFICE_SUCCESS,
  DELETE_OFFICE_FAILURE,
} from "../actions/officeActions";

const initialState = {
  offices: [],
  loading: false,
  creating: false,
  error: null,
  success: false,
};

const officeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OFFICES_REQUEST:
    case UPDATE_OFFICE_REQUEST:
    case DELETE_OFFICE_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case CREATE_OFFICE_REQUEST:
      return { ...state, creating: true, error: null, success: false };

    case FETCH_OFFICES_SUCCESS:
      return { ...state, loading: false, offices: action.payload };

    case CREATE_OFFICE_SUCCESS:
      return { ...state, creating: false, success: true };
      

    case UPDATE_OFFICE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        offices: state.offices.map((o) => (o.id === action.payload.id ? action.payload : o)),
      };

    case DELETE_OFFICE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true, error: action.payload
        // offices: state.offices.filter((o) => o.id !== action.payload),
      };

    case FETCH_OFFICES_FAILURE:
    case UPDATE_OFFICE_FAILURE:
    case DELETE_OFFICE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CREATE_OFFICE_FAILURE:
      return { ...state, creating: false, error: action.payload };

    default:
      return state;
  }
};

export default officeReducer;